import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import { formatDistanceToNowStrict } from "date-fns";
import {
  EntityOverviewHeader,
  OverviewTile,
} from "~/pages/manifold-nextgen/components/EntityOverviewHeader";
import { AccessLevelBadge } from "~/pages/manifold-nextgen/components/datasets/AccessLevelBadge";
import { PersonalDatasetIcon } from "~/pages/manifold-nextgen/components/datasets/PersonalDatasetIcon";
import usePersonalDataset from "~/pages/manifold-nextgen/hooks/usePersonalDataset";

const PERSONAL_DATASET_NAME = "My Dataset";

export const PersonalDatasetOverview = () => {
  const { data: dataset } = usePersonalDataset();

  if (!dataset) {
    return null;
  }

  const tiles: OverviewTile[] = [
    {
      label: "My Role",
      content: <AccessLevelBadge accessLevel={DatasetAccessLevel.OWNER} />,
    },
    {
      label: "Visibility",
      content: "Only you",
    },
    {
      label: "Created",
      content: formatDistanceToNowStrict(new Date(dataset.created_at), { addSuffix: true }),
    },
  ];

  return (
    <div className="mx-auto w-full max-w-3xl pb-12">
      <EntityOverviewHeader
        tiles={tiles}
        title={
          <div className="flex items-center gap-3">
            <PersonalDatasetIcon size={36} />
            <h1 className="text-xl font-semibold text-foreground">{PERSONAL_DATASET_NAME}</h1>
          </div>
        }
      >
        <p className="text-sm text-muted-foreground">
          A private space only you can see. Agents write draft tables and views into your Snowflake
          schema, and files into your S3 prefix — none of it is shared with anyone else until you
          promote a table into a dataset you own.
        </p>
      </EntityOverviewHeader>
    </div>
  );
};
